import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const REQUIRED_CONTRACT_FIELDS = [
  ["company_name", "Ragione Sociale", "text"],
  ["vat_number", "Partita IVA", "text"],
  ["tax_code", "Codice Fiscale", "text"],
  ["pec_email", "PEC", "email"],
  ["address", "Via e numero civico", "text"],
  ["cap", "CAP", "text"],
  ["city", "Città", "text"],
  ["province", "Provincia", "text"],
  ["administrator_full_name", "Nome e Cognome dell'Amministratore", "text"],
];

export const TenantContractFields = ({ values, onChange, prefix, required = true }) => (
  <>
    {REQUIRED_CONTRACT_FIELDS.map(([field, label, type]) => (
      <div key={field} className={field === "address" ? "sm:col-span-2" : "min-w-0"}>
        <Label htmlFor={`${prefix}-${field}`} className="text-xs uppercase tracking-widest text-[#8A8579]">
          {label}{required && " *"}
        </Label>
        <Input id={`${prefix}-${field}`} type={type} required={required}
               value={values[field] || ""} onChange={(e) => onChange(field, e.target.value)}
               autoComplete={field === "company_name" ? "organization" : type === "email" ? "email" : "off"}
               data-testid={`${prefix}-${field}`} />
      </div>
    ))}
  </>
);